module.exports = __webpack_public_path__ + "FixelDisplay-Light-a6444459ddf71636e02e7bc87e4630dd.woff2";